import { roles } from '@nxsys/store/constants';
import BankFileReportListing from '../../../modules/reports/bankFile/listing';

export const bankFileReportsConfig = [
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/reports/bank-files',
    element: <BankFileReportListing />,
  },
];
